const sans = 'InstrumentSans, Inter, -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif'

module.exports = {
  display: `BounceSans, ${sans}`,
  sans,
  mono: '"CourierPrime", monospace',
}
